var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-title',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path === '/'),expression:"$route.path === '/'"}]}),_c('home-main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }